// this must be an object, for test purposes it's a function
const USE_MARKETPLACE = context => {
  const locale = context.locale.iso;
  const cookies = context.$cookies;
  const result = {
    'fr-FR': true,
    'nl-BE': false,
    'fr-BE': false,
    'de-DE': false,
    'es-ES': false,
    'it-IT': false,
    'fr-LU': false,
    'nl-NL': false,
    'de-AT': false,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': false
  };

  if (cookies.get('withoutmarketplaceproducts')) {
    result['fr-FR'] = false;
  }

  return result[locale];
};

export const mvpMartketplace = false;
export default USE_MARKETPLACE;